// это когда со старой Free подписки тебя скинет на триал ендед
export const OLD_SUB_TO_TRIAL = 'OLD_SUBSCRIPTION_CHANGED_TO_DUMMY_PLAN'

// это когда со старой Free подписки тебя скинет на Education Free
export const OLD_SUB_TO_EDUCATION_FREE = 'OLD_SUBSCRIPTION_CHANGED_TO_EDUCATION_FREE'

// это когда со старой paid подписки тебя скинет на триал ендед
export const OLD_PAID_SUB_TO_TRIAL = 'PAID_SUBSCRIPTION_CHANGED_TO_DUMMY_PLAN'

// это когда новый юзер регнулся
export const NEW_SUB_TO_TRIAL = 'NEW_SUBSCRIPTION_CREATED_WITH_DUMMY_PLAN'

// когда Trial Ended /тариф был изменен
// на Trial 14 дней
export const TRIAL_ENDED_OR_SUB_TO_TRIAL = 'SUBSCRIPTION_TRIAL_RESETTED'

export const TRIAL_PRODUCT_CODE = '6531GA9GB2'

export const TRIAL_ENDED_PRODUCT_CODE = 'P2NMB9YH6X'

export const EDUCATION_GROUP_ID = 'EDUCATION'

export const PRODUCT_NAMES_LIST = {
    TrialEnded: 'Trial ended',
    Trial: 'Trial',
    Free: 'Free',
    Starter: 'Starter',
    Basic: 'Basic',
    Professional: 'Professional',
    Enterprise: 'Enterprise',
}

export const PRODUCT_LIST = {
    TrialEnded: 'P2NMB9YH6X',
    Trial: '6531GA9GB2',
    Free: '7D6DCC0440',
    Starter: '2444NE4LB5',
    StarterYear: '2444NE4LB5_YEAR',
    Basic: 'E8F83FBF8E',
    BasicYear: 'E8F83FBF8E_YEAR',
    Professional: '29D7A9C4F0',
    ProfessionalYear: '29D7A9C4F0_YEAR',
    Enterprise: 'E721588D11',
    EnterpriseYear: 'E721588D11_YEAR',
}

export const PRODUCT_LIST_FREE = {
    TrialEnded: 'P2NMB9YH6X',
    Trial: '6531GA9GB2',
    Free: '7D6DCC0440',
}

export const PRODUCT_LIST_PAID = {
    Starter: '2444NE4LB5',
    StarterYear: '2444NE4LB5_YEAR',
    Basic: 'E8F83FBF8E',
    BasicYear: 'E8F83FBF8E_YEAR',
    Professional: '29D7A9C4F0',
    ProfessionalYear: '29D7A9C4F0_YEAR',
    Enterprise: 'E721588D11',
    EnterpriseYear: 'E721588D11_YEAR',
}

export const EDUCATION_PRODUCT_LIST = {
    EducationFree: 'M0AC33DDDP',
    EducationBeginner: '7047IK6EZ7',
    EducationBeginnerYear: '7047IK6EZ7_YEAR',
    EducationIntermediate: 'VPQ3RKVNEO',
    EducationIntermediateYear: 'VPQ3RKVNEO_YEAR',
    EducationAdvanced: 'KVVOIGRPU3',
    EducationAdvancedYear: 'KVVOIGRPU3_YEAR',
}
